import React, { useContext } from "react";
import styled from "styled-components";

import { Radio as CoeffRadio } from "../../common/Radio";
import { PPressContextParams, PpressContext, PPressComponentProps } from "../context";

const StyledRadioGroup = styled(CoeffRadio.Group)`
  .ant-radio-wrapper {
    display: block;
    margin: 5px auto;
  }
`;

type PPressRadioProps = {
  name: string;
  options: [{ [key: string]: any }];
  className?: string;
  disabled?: boolean;
  mode?: "vertical" | "horizontal";
  onChange?: (value: string) => void;
} & PPressComponentProps;

export const RadioGroup = (props: PPressRadioProps) => {
  const { name, options, triggersOnChange, onChange } = props;

  const form_state = useContext(PpressContext) as PPressContextParams;

  return (
    <StyledRadioGroup
      value={form_state?.ppress_params[name]}
      onChange={async e => {
        if (onChange) {
          onChange(e.target.value);
          return;
        }

        if (props.updateFromServerOnChange) {
          await form_state.updateFormFromServer({
            ...form_state?.ppress_params,
            [name]: e.target.value,
          });
        } else {
          form_state.updatePPressParams({ [name]: e.target.value });

          if (triggersOnChange) {
            form_state.triggersOnChange(triggersOnChange);
          }
        }
      }}
      className={`coeff__ppress_radiogroup ${props.mode === "vertical" ? "vertical" : ""} ${
        props.className
      }`}
      data-test-id={`ppress-radio-group-${name}`}
    >
      {options?.map(({ value, label }, i) => (
        <CoeffRadio key={i} value={value}>
          {label}
        </CoeffRadio>
      ))}
    </StyledRadioGroup>
  );
};
